import React from 'react';

const FileNotFound = () => {
    return (
        <div className=' grayBlurShadow w-100 p-3 rounded-3 h-100'>
            <i className="ri-file-warning-line label-icon  fs-1 " />
            <h3 className=' text-black'>File Not Found</h3>
            <p>It may have beed moved, edited or deleted.</p>
            <small className=' text-muted'>ERR_FILE_NOT_FOUND</small>
        </div>
    );
}

export default FileNotFound;
